import e, { useRef as n, useState as t, useEffect as r } from "react";
import o from "react-loading-skeleton";

function i(e, n) {
  void 0 === n && (n = {});
  var t = n.insertAt;

  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
        o = document.createElement("style");
    o.type = "text/css", "top" === t && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}

i("/* common */\n.Container {\n  text-align: left;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  border-radius: 7px;\n  border: 1px solid #ccc;\n  color: black;\n  transition: 0.3s all ease;\n  height: fit-content; }\n  .Container:hover {\n    background-color: #fafafa !important;\n    cursor: pointer; }\n\n.Secondary {\n  color: #646464; }\n\n.LowerContainer {\n  padding: 10px; }\n\n.Title {\n  margin-top: 0;\n  margin-bottom: 10px; }\n\n.Image {\n  width: 100%;\n  border-top-left-radius: 7px;\n  border-top-right-radius: 7px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  height: 30vh; }\n\n.SiteDetails {\n  margin-top: 10px; }\n\n/* sm */\n@media (max-width: 640px) {\n  .Description {\n    display: none; } }\n\n/* md */\n@media (min-width: 641px) and (max-width: 768px) {\n  .Description {\n    display: none; } }\n");
i(".skeleton-container {\n  border-radius: 7px;\n  border: 1px solid #eee; }\n\n.skeleton-lower-container {\n  padding: 10px; }\n");

var a = function a(n) {
  var t = n.width,
      r = void 0 === t ? "100%" : t,
      i = n.imageHeight,
      a = void 0 === i ? "30vh" : i,
      l = n.margin;
  return e.createElement("div", {
    className: "skeleton-container",
    style: {
      width: r,
      margin: l
    }
  }, e.createElement(o, {
    width: r,
    height: a
  }), e.createElement("div", {
    className: "skeleton-lower-container"
  }, e.createElement(o, {
    count: 3
  })));
};

var l = function l(o) {
  var i = o.url,
      l = o.className,
      c = void 0 === l ? "" : l,
      d = o.width,
      s = o.height,
      m = o.descriptionLength,
      u = o.borderRadius,
      h = o.imageHeight,
      p = o.textAlign,
      g = o.margin,
      f = o.fallback,
      v = void 0 === f ? null : f,
      b = o.backgroundColor,
      x = void 0 === b ? "white" : b,
      y = o.primaryTextColor,
      w = void 0 === y ? "black" : y,
      k = o.secondaryTextColor,
      E = void 0 === k ? "rgb(100, 100, 100)" : k,
      C = o.borderColor,
      N = void 0 === C ? "#ccc" : C,
      T = o.showLoader,
      L = void 0 === T || T,
      R = o.customLoader,
      S = void 0 === R ? null : R,
      D = o.openInNewTab,
      I = void 0 === D || D,
      A = o.fetcher,
      H = n(!0),
      B = t(),
      F = B[0],
      U = B[1],
      _ = t(!0),
      j = _[0],
      z = _[1];

  if (r(function () {
    return H.current = !0, z(!0), A ? A(i).then(function (e) {
      H.current && (!function (e) {
        return void 0 !== e.title && void 0 !== e.description && void 0 !== e.image && void 0 !== e.siteName && void 0 !== e.hostname;
      }(e) ? U(null) : U(e), z(!1));
    }).catch(function (e) {
      console.error(e), console.error("No metadata could be found for the given URL."), H.current && (U(null), z(!1));
    }) : fetch("https://rlp-proxy.herokuapp.com/v2?url=" + i).then(function (e) {
      return e.json();
    }).then(function (e) {
      H.current && (U(e.metadata), z(!1));
    }).catch(function (e) {
      console.error(e), console.error("No metadata could be found for the given URL."), H.current && (U(null), z(!1));
    }), function () {
      H.current = !1;
    };
  }, [i, A]), j && L) return S ? e.createElement(e.Fragment, null, S) : e.createElement(a, {
    width: d,
    imageHeight: h,
    margin: g
  });
  if (!F) return e.createElement(e.Fragment, null, v);
  var q = F.image,
      G = F.description,
      J = F.title,
      K = F.siteName,
      M = F.hostname;
  return e.createElement("div", {
    "data-testid": "container",
    onClick: function onClick() {
      var e = I ? "_blank" : "_self";
      window.open(i, e);
    },
    className: "Container " + c,
    style: {
      width: d,
      height: s,
      borderRadius: u,
      textAlign: p,
      margin: g,
      backgroundColor: x,
      borderColor: N
    }
  }, e.createElement("div", {
    "data-testid": "image-container",
    style: {
      borderTopLeftRadius: u,
      borderTopRightRadius: u,
      backgroundImage: "url(" + q + ")",
      height: h
    },
    className: "Image"
  }), e.createElement("div", {
    className: "LowerContainer"
  }, e.createElement("h3", {
    "data-testid": "title",
    className: "Title",
    style: {
      color: w
    }
  }, J), G && e.createElement("span", {
    "data-testid": "desc",
    className: "Description Secondary",
    style: {
      color: E
    }
  }, m && G.length > m ? G.slice(0, m) + "..." : G), e.createElement("div", {
    className: "Secondary SiteDetails",
    style: {
      color: E
    }
  }, K && e.createElement("span", null, K, " • "), e.createElement("span", null, M))));
};

export { l as LinkPreview };